import React from 'react'
import { Radio } from 'antd'
import { RadioChangeEvent } from 'antd/lib/radio'

import Typography from 'components/UI/Typography/Typography'

import styles from './OptionGroup.module.css'

type ClickableWrapperProps = {
  handleOnClick?: () => void
  children: JSX.Element
}

const ClickableWrapper = ({
  handleOnClick,
  children,
}: ClickableWrapperProps) => {
  if (!handleOnClick) {
    return children
  }

  return (
    <span
      className={styles.titleButton}
      tabIndex={0}
      role="button"
      onClick={handleOnClick}
    >
      {children}
    </span>
  )
}

type OptionGroupProps = {
  title: string
  titleIcon?: React.ReactNode
  handleTitleOnClick?: () => void
  legend?: string
  handleOnChange: (e?: RadioChangeEvent) => void
  checkedValue: string | boolean
  children: React.ReactNode
}

const OptionGroup = ({
  title,
  titleIcon,
  handleTitleOnClick,
  legend,
  handleOnChange,
  checkedValue,
  children,
}: OptionGroupProps): JSX.Element => (
  <div className={styles.wrapper}>
    <ClickableWrapper handleOnClick={handleTitleOnClick}>
      <Typography.H6 className={styles.title}>
        {title}
        {titleIcon && <span className={styles.titleIcon}>{titleIcon}</span>}
      </Typography.H6>
    </ClickableWrapper>

    {legend && (
      <Typography.Body className={styles.legend}>{legend}</Typography.Body>
    )}

    <Radio.Group
      onChange={handleOnChange}
      className={styles.options}
      value={checkedValue}
    >
      {React.Children.map(children, (child) =>
        React.cloneElement(child as JSX.Element, {
          checkedValue,
        }),
      )}
    </Radio.Group>
  </div>
)

export default OptionGroup
